import type { DashboardSpec } from "../dashboard/catalog"

function hashFingerprint(value: string): string {
  let hash = 0x811c9dc5
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 0x01000193)
  }
  return (hash >>> 0).toString(16).padStart(8, "0")
}

/**
 * Stable while a response moves from `streamingAnswer` into `messages`.
 * The logical answer index increments for a later turn, so an intentionally
 * repeated edit remains valid.
 */
export function getIncrementalEditApplicationKey(
  sessionId: string | null | undefined,
  logicalAnswerIndex: number,
  fingerprint: string
): string {
  return `${sessionId ?? "new"}:${logicalAnswerIndex}:${hashFingerprint(fingerprint)}`
}

export function wasIncrementalEditApplied(
  spec: DashboardSpec,
  applicationKey: string | null
): boolean {
  return applicationKey !== null && spec._lastIncrementalEditKey === applicationKey
}

export function markIncrementalEditApplied(
  spec: DashboardSpec,
  applicationKey: string
): DashboardSpec {
  return { ...spec, _lastIncrementalEditKey: applicationKey }
}

/** A relative edit may only be applied once inside one outbound user turn. */
export function shouldApplyIncrementalResponse(
  lastFingerprint: string | null,
  nextFingerprint: string | null
): boolean {
  return nextFingerprint !== null && lastFingerprint !== nextFingerprint
}
